import k from '../constants/k'

k.loadSprite('witch', 'sprites/witch.png', {
  sliceX: 6,
  anims: {
    default: 0,
    walking: {
      from: 2,
      to: 5,
      loop: true,
      speed: 4
    }
  }
})
const speed = 100
const offset = 4

export default () => {
  const player = k.add([k.sprite('witch'), k.pos(60, 74), k.anchor('center')])
  let target: number | null = null

  k.onClick('background', () => {
    target = k.mousePos().x
    player.play('walking')
  })

  player.onUpdate(() => {
    if (target) {
      if (player.pos.x - offset > target) {
        player.move(-speed, 0)
        player.flipX = true
      } else if (player.pos.x + offset < target) {
        player.move(speed, 0)
        player.flipX = false
      } else {
        target = null
        player.play('default')
      }
    }
  })
}
